import { Injectable } from "@angular/core"
import { Resolve, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router"
import { Observable } from "rxjs/Observable"
import { Observer } from "rxjs/Observer"
import { Store, Action } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { MatrixClassEffects } from "@reducers/effects/matrix-class"
import {
  POPULATE_CLASSES,
  FETCH_CLASSES
} from "@reducers/matrix-class"

@Injectable()
export class ClassManagerViewResolver implements Resolve<boolean> {

  constructor(
    private classEffects: MatrixClassEffects,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const result: Observable<boolean> = Observable.create(
      (observer: Observer<boolean>) => {
        // Add Resolves here as necessary.
        observer.next(true)
        observer.complete() })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/class-manager-view.ts